import type { ComponentProps } from 'react'
import { useTranslations } from 'next-intl'
import { Link } from '@hello-aria/ui/link'
import AppLink from './Link'

export type ExternalLinkProps = Omit<
    ComponentProps<typeof Link>,
    'isExternal' | 'externalLabel' | 'render' | 'href'
> & {
    href: string
}

const ExternalLink = ({ href, ...props }: ExternalLinkProps) => {
    const t = useTranslations('root')

    // Rendered through the app's own link, which adds the locale and the selected company to an in-app href.
    return (
        <Link
            {...props}
            isExternal
            externalLabel={t('externalLink.opensInNewTab')}
            render={<AppLink href={href}>{null}</AppLink>}
        />
    )
}

export default ExternalLink
